import React from "react";
import { ContractActionMenuHook } from "./useContractActionMenu";
import ChangeContractQuantityModal from "./ChangeContractQuantityModal";
import ConfirmationModal from "common/ui/ConfirmationModal";
import AddOfferModal from "features/offers/AddOfferModal";
import { ContractType } from "domain/contract";
import RequestContractSignatureModal from "./RequestContractSignatureModal";
import SyncContractToErpRetryModal from "./SyncContractToErpRetryModal";
import SplitContractModal from "./splitContracts/SplitContractModal";
import RollContractsModal from "./rollContracts/RollContractsModal";
import EditContractModal from "./EditContractModal";

interface ContractActionsProps extends ContractActionMenuHook {
    onActionCompleted?(): void;
}

const ContractActions: React.FC<ContractActionsProps> = React.memo((props) => {
    return <>
        {props.changeQuantityState.isShowing && (
            <ChangeContractQuantityModal
                contract={props.changeQuantityState.data.contract}
                isSupervisorEditing={props.changeQuantityState.data.isSupervisorEditing}
                onClose={props.changeQuantityState.hide}
                onContractUpdated={props.onActionCompleted}
            />
        )}
        {props.editContractState.isShowing && (
            <EditContractModal
                contract={props.editContractState.data}
                onClose={props.editContractState.hide}
                onContractUpdated={props.onActionCompleted}
            />
        )}
        {props.addOfferState.isShowing && (
            <AddOfferModal
                model={props.addOfferState.data.model}
                isPricingDelayedPriceContractModal={props.addOfferState.data.contractType === ContractType.DelayedPrice}
                isPricingWithBasisOffer={props.addOfferState.data.basisOffer}
                isConvertBushelOnly={props.addOfferState.data.contractType === ContractType.BushelOnly}
                onClose={props.addOfferState.hide}
                onAdded={props.onActionCompleted}
            />
        )}
        {props.contractSignatureState.isShowing && (
            <RequestContractSignatureModal
                contractDisplayId={props.contractSignatureState.data?.displayId}
                contractId={props.contractSignatureState.data?.id}
                notificationSuccessMessage="Contract signature request sent!"
                onClose={props.contractSignatureState.hide}
                onFinish={props.onActionCompleted}
            />
        )}
        {props.resyncState.isShowing && (
            <SyncContractToErpRetryModal modalState={props.resyncState} />
        )}
        {props.rollState.isShowing && (
            <RollContractsModal
                contractType={props.rollState.data.contractType}
                contract={props.rollState.data}
                onClose={props.rollState.hide}
                onContractsRolled={props.onActionCompleted}
            />
        )}
        {props.splitState.isShowing && (
            <SplitContractModal
                contract={props.splitState.data}
                onClose={props.splitState.hide}
                onContractSplit={props.onActionCompleted}
            />
        )}

        <ConfirmationModal modalState={props.confirmModal.state} />
    </>;
});

export default ContractActions;
